import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Link from "components/common/Link";

const CouponsHeading = () => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6" color="#707070">
        Coupons
      </Typography>
      <Link to="/add/coupons" style={{ textDecoration: "none" }}>
        <Chip
          label="+ Coupons"
          sx={{
            alignItems: "center",
            padding: "0 8px",
            backgroundColor: "unset !important ",
            color: "#004AAD",
            border: "1px solid #004AAD",
          }}
        />
      </Link>
    </Stack>
  );
};

export default CouponsHeading;
